import { useRef, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
} from "@material-ui/core";
import useAuth from "../../hooks/useAuth";
import CogIcon from "../../icons/Cog";
import UserIcon from "../../icons/User";
import ResetPasswordModal from "./ResetPassword/ResetPasswordModal";
import { useTranslation } from "react-i18next";
const AccountPopover = () => {
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const { t } = useTranslation();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("Unable to logout.");
    }
  };
  function handleResetPasswordOpen() {
    setResetPasswordModalOpen(true);
  }

  function handleResetPasswordClose() {
    setResetPasswordModalOpen(false);
  }

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: "center",
          display: "flex",
        }}
      >
        <Avatar
          src={user.avatar}
          sx={{
            height: 32,
            width: 32,
          }}
        />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography color="textPrimary" variant="h5">
            {user.first_name
              ? `${user.first_name} ${user.last_name || ""}`
              : user.name}
          </Typography>
          <Typography color="textSecondary" variant="subtitle2">
            {/* Devias */}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          {user.is_superuser == false && user.is_staff == false ? (
            <MenuItem component={RouterLink} to="/customerdashboard/account">
              <ListItemIcon>
                <UserIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography color="textPrimary" variant="subtitle2">
                    Profile
                  </Typography>
                }
              />
            </MenuItem>
          ) : (
            ""
          )}

          {/* <MenuItem
            component={RouterLink}
            to="/dashboard/account"
          >
            <ListItemIcon>
              <CogIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Settings
                </Typography>
              )}
            />
          </MenuItem>
        */}
        </Box>
        <Box sx={{ p: 2, pb: 0 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleResetPasswordOpen}
            variant="outlined"
          >
            {t("Reset Password")}
          </Button>
        </Box>
        <Box sx={{ p: 2, pt: 1 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            {t("Logout")}
          </Button>
        </Box>
      </Popover>

      <ResetPasswordModal
        onApply={handleResetPasswordClose}
        onClose={handleResetPasswordClose}
        open={resetPasswordModalOpen}
      />
    </>
  );
};

export default AccountPopover;
